import { Api, requestRefresh } from './Api';

const auth = async (email, senha) => {
    try {
        const response = await Api.post('/auth', { email, senha });
        return response.data;
    } catch (error) {
        return new Error(error?.response?.data?.message || 'Credenciais inválidas');
    }
};

const me = async () => {
    try {
        const response = await Api.get('/auth/me');
        return response.data;
    } catch (error) {
        return null;
    }
};

const refresh = async () => {
    return requestRefresh();
};

const logout = async () => {
    try {
        await Api.post('/auth/logout');
        return true;
    } catch {
        return false;
    }
};

export const AuthService = {
    auth,
    me,
    refresh,
    logout
};
